import { Phone, Mail, ArrowRight, Home, MapPin } from "lucide-react";

const CTASection = () => {
  return (
    <section id="cta" className="py-16 md:py-24 bg-gradient-to-br from-accent to-accent/95">
      <div className="px-6 md:px-16 max-w-7xl mx-auto">
        <div className="grid md:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <div>
            <h2 className="font-open-sans font-bold text-3xl md:text-5xl text-accent-foreground mb-6">
              Ready to Find Your Perfect Address Behind the Gate?
            </h2>
            <p className="font-open-sans text-lg leading-relaxed text-accent-foreground/90 mb-8">
              Whether you're looking to buy, rent, or invest in Nairobi's premium real estate market, 
              our team of hyper-local experts is ready to guide you to your perfect property. 
              Let us help you discover the lifestyle you deserve.
            </p>
            
            <div className="space-y-4 mb-8">
              <div className="flex items-center gap-3">
                <MapPin className="w-5 h-5 text-accent-foreground/80" />
                <span className="font-open-sans text-sm text-accent-foreground/80">
                  Westlands, Nairobi, Kenya
                </span>
              </div>
              <div className="flex items-center gap-3">
                <Phone className="w-5 h-5 text-accent-foreground/80" />
                <span className="font-open-sans text-sm text-accent-foreground/80">
                  +254 111 653 233
                </span>
              </div>
              <div className="flex items-center gap-3">
                <Mail className="w-5 h-5 text-accent-foreground/80" />
                <span className="font-open-sans text-sm text-accent-foreground/80">
                  info@wildgates.co.ke
                </span>
              </div>
            </div>
          </div>

          {/* Right Content - Contact Form */}
          <div className="bg-accent-foreground/10 backdrop-blur-sm rounded-xl p-8">
            <h3 className="font-open-sans font-bold text-2xl text-accent-foreground mb-6">
              Start Your Journey
            </h3>
            <form className="space-y-4" onSubmit={(e) => e.preventDefault()}>
              <div>
                <input
                  type="text"
                  placeholder="Your Name"
                  className="w-full bg-accent-foreground/20 border border-accent-foreground/30 rounded-md px-4 py-3 font-open-sans text-sm text-accent-foreground placeholder-accent-foreground/60 focus:outline-none focus:border-accent-foreground transition-colors"
                />
              </div>
              <div>
                <input
                  type="email"
                  placeholder="Email Address"
                  className="w-full bg-accent-foreground/20 border border-accent-foreground/30 rounded-md px-4 py-3 font-open-sans text-sm text-accent-foreground placeholder-accent-foreground/60 focus:outline-none focus:border-accent-foreground transition-colors"
                />
              </div>
              <div>
                <input
                  type="tel"
                  placeholder="Phone Number"
                  className="w-full bg-accent-foreground/20 border border-accent-foreground/30 rounded-md px-4 py-3 font-open-sans text-sm text-accent-foreground placeholder-accent-foreground/60 focus:outline-none focus:border-accent-foreground transition-colors"
                />
              </div>
              <div>
                <select className="w-full bg-accent-foreground/20 border border-accent-foreground/30 rounded-md px-4 py-3 font-open-sans text-sm text-accent-foreground focus:outline-none focus:border-accent-foreground transition-colors">
                  <option value="" className="text-accent-foreground">I'm interested in...</option>
                  <option value="sale" className="text-accent-foreground">Properties for Sale</option>
                  <option value="rent" className="text-accent-foreground">Properties for Rent</option>
                  <option value="investment" className="text-accent-foreground">Off-Plan Investments</option>
                  <option value="consultation" className="text-accent-foreground">General Consultation</option>
                </select>
              </div>
              <button
                type="submit"
                className="w-full bg-accent-foreground text-accent rounded-md px-6 py-3 font-open-sans font-semibold tracking-wider uppercase hover:bg-accent-foreground/90 transition-colors flex items-center justify-center gap-2"
              >
                Get Started
                <ArrowRight className="w-4 h-4" />
              </button>
            </form>
            
            <div className="mt-6 text-center">
              <p className="font-open-sans text-xs text-accent-foreground/70">
                Or call us directly at 
                <a href="tel:+254111653233" className="text-accent-foreground hover:underline ml-1">
                  +254 111 653 233
                </a>
              </p>
            </div>
          </div>
        </div>

        {/* Bottom Stats */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mt-16 pt-16 border-t border-accent-foreground/20">
          <div className="text-center">
            <p className="font-display text-2xl md:text-3xl font-light text-accent-foreground mb-2">5+</p>
            <p className="font-body text-xs text-accent-foreground/70 uppercase tracking-wider">Prime Locations</p>
          </div>
          <div className="text-center">
            <p className="font-display text-2xl md:text-3xl font-light text-accent-foreground mb-2">100+</p>
            <p className="font-body text-xs text-accent-foreground/70 uppercase tracking-wider">Premium Properties</p>
          </div>
          <div className="text-center">
            <p className="font-display text-2xl md:text-3xl font-light text-accent-foreground mb-2">3+</p>
            <p className="font-body text-xs text-accent-foreground/70 uppercase tracking-wider">Years Experience</p>
          </div>
          <div className="text-center">
            <p className="font-display text-2xl md:text-3xl font-light text-accent-foreground mb-2">100%</p>
            <p className="font-body text-xs text-accent-foreground/70 uppercase tracking-wider">Client Satisfaction</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
